import React from 'react'





import Footer from '../../Footer/Footer'
import EngineeringTechnicalHero from './EngineeringTechnicalHero'
import EngineeringTechnicalContent from './EngineeringTechnicalContent'
import EngineeringTechnicalServices from './EngineeringTechnicalServices'
import EngineeringTechnicalTrustSection from './EngineeringTechnicalTrustsection'
import EngineeringTechnicalTransform from './EngineeringTechnicalTransform'

function EngineeringTechnicalCorporate() {
    return (
        <div>
            <EngineeringTechnicalHero/>
            <EngineeringTechnicalContent/>
            <EngineeringTechnicalServices/>
            <EngineeringTechnicalTrustSection/>
            <EngineeringTechnicalTransform/>
            <Footer/>
            
        </div>
    )
}

export default EngineeringTechnicalCorporate
